import type { RouteLocationNormalized } from "vue-router";
import type { TypedRoute } from "../../.nuxt/typed-router/__router";

export default (to: RouteLocationNormalized | TypedRoute) =>
    (typeof to.name === "string" &&
        ["login", "entrance", "reset-password-token"].includes(to.name)) ??
    false;
